import * as Yup from 'yup';

export const planReviewTaskSelectFormSchema = Yup.object().shape({
  // bluePrint: Yup.string().required('Blueprint is required'),
});
